import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  // `useLocation` kancası, URL'deki değişikliği (rota değişikliğini) algılar.
  const { pathname } = useLocation();

  // `pathname` her değiştiğinde bu `useEffect` çalışır.
  useEffect(() => {
    // Pencereyi, animasyon olmadan, anında en üste (0, 0) kaydırır.
    window.scrollTo(0, 0);
  }, [pathname]);

  // Bu bileşen görsel bir şey render etmez, sadece bir işlev görür.
  return null;
};

export default ScrollToTop;